<dx-data-grid
  *ngIf="overheadsResource"
  [glamResource]="overheadsResource"
  class="flex-1"
  (onInitialized)="onGridInitialized($event.component!)"
  [createComponent]="overheadsAddComponent"
  [customParams]="addCustomParams"
  (entityCreated)="reloadGrid()"
  (entityDeleted)="reloadGrid()"
  (refreshEmit)="reloadGrid()"
  [disabledAdd]="!isDraft"
  [disabledDelete]="!isDraft"
>
  <dxo-editing [allowUpdating]="false" mode="row"></dxo-editing>

  <dxi-column
    dataField="plantId"
    dataType="string"
    [caption]="'common.tabTitle.plant' | translate | ucfirst"
  >
    <dxo-lookup [dataSource]="plants" displayExpr="name" valueExpr="id" />
  </dxi-column>
  <dxi-column
    dataField="sectionId"
    dataType="string"
    [caption]="'common.tabTitle.section' | translate | ucfirst"
  >
    <dxo-lookup [dataSource]="sections" displayExpr="name" valueExpr="id" />
  </dxi-column>
  <dxi-column
    dataField="workCenterId"
    dataType="string"
    [caption]="'common.tabTitle.workcenter' | translate | ucfirst"
  >
    <dxo-lookup [dataSource]="workcenters" displayExpr="name" valueExpr="id" />
  </dxi-column>

  <dxi-column
    dataField="description"
    [caption]="'entity.overhead.description' | translate | ucfirst"
    cellTemplate="descTpl"
  ></dxi-column>
  <div *dxTemplate="let cell of 'descTpl'">
    <div
      class="hover:underline cursor-pointer"
      (click)="openOverhead(cell.data)"
      *ngIf="canWriteOverheads; else plainDesc"
    >
      {{ cell.value }}
    </div>
    <ng-template #plainDesc>{{ cell.value }}</ng-template>
  </div>

  <dxi-column
    dataField="currentCost"
    gsCurrencyColumn
    dataType="number"
    [caption]="'entity.overhead.currentCost' | translate | ucfirst"
  ></dxi-column>
  <dxi-column
    dataField="formatId"
    dataType="string"
    [caption]="'entity.overhead.formatId' | translate | ucfirst"
  >
    <dxo-lookup [dataSource]="formats" displayExpr="name" valueExpr="id" />
  </dxi-column>
  <dxi-column
    dataField="currentCostDate"
    dataType="date"
    [caption]="'common.lastUpdated' | translate | ucfirst"
  ></dxi-column>
</dx-data-grid>

